module.exports = __webpack_public_path__ + "static/media/bar-chart-statistics.e2294cc3.svg";